import { $ } from '@/libs/jquery/index'

export class CsrfToken {

  private selectors: ISelectors = {
    base: 'meta[name=csrf-token]',
  }

  public constructor() {
    this.init()
  }

  private init(): void {
    $(document).ajaxComplete((e, xhr, settings) => {
      const headerToken = xhr.getResponseHeader('X-CSRF-Token')
      if (headerToken) {
        $(this.selectors.base).attr('content', headerToken)
      }
    })
  }
}
